<template>
  <w-sliding-popup ref="slidingPopup" :title="`[${popupParams.label}] 신규 추가`" width="600px">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
      </el-steps>
      <w-report-basic-info-view ref="basicInfo" v-show="activeStep === 1" :popup-params="popupParams" />
      <w-report-option-info-view ref="optionInfo" v-show="activeStep === 2" :attr-data="popupParams.attrData" />
      <w-report-info-check-view ref="checkInfo" v-if="activeStep === 3" :attr-data="popupParams.attrData" :report-basic-info="reportBasicInfo" :report-option-info="reportDetailOptionInfo" />
    </div>
    <el-row slot="footer" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep !== 1" @click="prevStep">
          <i class="fal fa-arrow-left mr-r2"></i>이전 단계
        </el-button>
      </div>
      <div>
        <el-button type="solid" size="large" v-if="activeStep === 3" @click="addReport">등록</el-button>
        <el-button type="solid" size="large" v-else @click="nextStep">다음 단계</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import reportApi from '@/api/report/report';
import WReportBasicInfoView from './components/ReportBasicInfoView';
import WReportOptionInfoView from './components/ReportOptionInfoView';
import WReportInfoCheckView from './components/ReportInfoCheckView';

export default {
  name: 'WAddReportPopup',
  components: {
    WReportBasicInfoView,
    WReportOptionInfoView,
    WReportInfoCheckView,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stepTitles: ['기본정보 입력', '보고서 옵션 설정', '정보 확인'],
      activeStep: 1,
      reportOptionInfo: {},
      reportBasicInfo: {},
    };
  },
  methods: {
    open() {
      this.activeStep = 1;
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.$refs.basicInfo.initBasicInfo();
        this.$refs.optionInfo.initOptionInfo();
      });
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    nextStep() {
      if (this.activeStep === 1) {
        const validation = this.$refs.basicInfo.getReportBasicInfo();
        validation.validatePromise.then((response) => {
          if (response) {
            this.reportBasicInfo = validation.reportBasicInfo;
            this.activeStep = this.activeStep + 1;
          }
        }).catch(() => {
          this.$message(msgUtil.getCustomMsgData('데이터를 확인해 주십시오.'));
        });
      } else if (this.activeStep === 2) {
        const optionInfo = this.$refs.optionInfo.getReportOptionInfo();
        const detailOptionInfo = this.$refs.optionInfo.getReportDetailOptionInfo();
        if (optionInfo !== false) {
          this.reportOptionInfo = optionInfo;
          this.reportDetailOptionInfo = detailOptionInfo;
          this.activeStep = this.activeStep + 1;
        }
      }
    },
    addReport() {
      const params = this.reportBasicInfo;
      params.reportConfSet = JSON.stringify(this.reportOptionInfo);
      params.registDatetime = new Date().getTime();

      const target = '보고서';
      const action = msgUtil.action.ADD;
      reportApi.addReport(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.$emit('load-tree-data', `${this.popupParams.treeKey}.${response.data.data}`);
          this.close();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          this.$message.error('보고서를 추가하지 못하였습니다.');
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/AddReportPopup.vue